<script>
import request from '@/found/utils/request';
import tablePageListBase from '../../../components/table_page_list_base';
import TablePage from './table';

export default {
  extends: tablePageListBase,
  components: {
    TablePage,
  },
  data() {
    return {
      placeholder: '请输入商超系统名称',
      title: '商超系统',
      restful: '/kms/kmsdirectsystem/list',
      defaultProps: {
        label: 'directName',
        value: 'id',
      },
      searchName: 'directName',
      isAdd: true,
      // operationBtns: [
      //   {
      //     command: 'enable',
      //     btntext: '启用',
      //   },
      //   {
      //     command: 'disabled',
      //     btntext: '禁用',
      //   },
      //   {
      //     command: 'remove',
      //     btntext: '移除',
      //   },
      // ],
    };
  },
  methods: {
    /**
     * 操作按钮
     * @params command 操作按钮的command
     * @params node 操作行的node
     */
    handleCommand({ command, node }) {
      if (command === 'enable') {
        request.post('/kms/kmstenantrydirectcustomerorg/enable', [node.data.id]).then((res) => {
          if (res.success) {
            this.$message.success('操作成功！');
          }
        });
      }
      if (command === 'disabled') {
        request.post('/kms/kmstenantrydirectcustomerorg/disable', [node.data.id]).then((res) => {
          if (res.success) {
            this.$message.success('操作成功！');
          }
        });
      }
      if (command === 'remove') {
        request.post('/kms/kmstenantrydirectcustomerorg/delete', [node.data.id]).then((res) => {
          if (res.success) {
            this.$message.success('操作成功！');
          }
        });
      }
    },
  },
};
</script>
